var styles = {
  "unit-base": "4",
  "input": "web_ui__Input__input",
  "value": "web_ui__Input__value",
  "with-suffix": "web_ui__Input__with-suffix",
  "title": "web_ui__Input__title",
  "content": "web_ui__Input__content",
  "suffix": "web_ui__Input__suffix",
  "note": "web_ui__Input__note",
  "narrow": "web_ui__Input__narrow",
  "tight": "web_ui__Input__tight",
  "wide": "web_ui__Input__wide",
  "primary": "web_ui__Input__primary",
  "select": "web_ui__Input__select",
  "placeholder": "web_ui__Input__placeholder"
};

export { styles as s };
//# sourceMappingURL=Input-73709b6d.js.map
